export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [],
        dataTableOptions: {
            global_search: {
                visibility: false,
            }
        },
        formActions: [],
        rowActions: [
            {
                btn_text: '<i class="fas fa-check"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'loadRow',
                additionalButtonVisible: 'loadButtonVisible'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "fileName",
                label: "Fájl név",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true
            },
            {
                name: "filePath",
                label: "Fájl helye",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true
            },
            {
                name: "fileSizeMb",
                label: "Fájl mérete (Mb)",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "fileType",
                label: "Fájl típusa",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "loaded",
                label: "Betöltve",
                visibility: true,
                slot_name: "loaded_format"
            },
            {
                name: "loadedText",
                label: "Betöltött",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "createdBy",
                label: "Feltöltötte",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "createdOn",
                label: "Feltöltés ideje",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
